import React from 'react';
import PrimePage from './PrimePage';
const AncillariesPages = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrimePage, null));
export default AncillariesPages;